module.exports = __webpack_public_path__ + "static/media/change-pwd-icon.25007899.svg";